import { customAlphabet } from 'nanoid';

/**
 * Aguardar número de milissegundos informados, se chamado com await
 * Exemplo: await sleep(1000);
 */
export function sleep(ms: number): Promise<unknown> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * Retornar idioma traduzível pelo Hmax Web com base no locale
 */
export function getLanguageByLocale(locale?: string): string {
  const prefix = locale?.substring(0, 2)?.toLocaleLowerCase() ?? '';
  // Se for pt retornar pt-BR, se for es retornar es-ES, se for qualquer outro retornar en-US
  if (['pt', 'es'].includes(prefix)) {
    return prefix;
  }
  return 'en';
}

/**
 * Formatar horário para o formato HH:MM, removendo os segundos se existirem
 * Exemplo: 14:30:00 -> 14:30
 */
export function formatTimeForInput(time?: string): string | undefined {
  if (!time) return undefined;
  const parts = time.split(':');
  if (parts.length >= 2) {
    return `${parts[0]}:${parts[1]}`;
  }
  return time;
}

/**
 * Formatar horário para o formato HH:MM:SS, adicionando os segundos se não existirem
 * Exemplo: 14:30 -> 14:30:00
 */
export function formatTimeForBackend(time?: string | null): string | null | undefined {
  if (!time) return time;
  const parts = time.split(':');
  if (parts.length === 2) {
    return `${parts[0]}:${parts[1]}:00`;
  }
  return time;
}

/**
 * Retornar nano id conforme parâmetros pré-definidos para evitar confusão com números
 * @param length Quantidade de caracteres do nanoId. Default 7;
 */
export function getNanoId(length = 7) {
  // Configuração de geração do Nano Id da reserva.
  // Alguns caracteres foram removidos para evitar confusão com números
  const acceptedChars = '0123456789ABCDEFGHJKLMNPQRTUVWXYZ';
  return customAlphabet(acceptedChars, length)();
}
